import ActionType from './ActionType'
import { Auth } from 'utils/Auth'
import API_URL from 'utils/ApiUrl'
import { create, update } from 'actions/data'

export const clickContactToText = payload => dispatch =>
  dispatch({
    type: ActionType.SMS.CLICK_CONTACT_TO_TEXT,
    payload,
  })

export const handleMultiChange = newValue => dispatch =>
  dispatch({
    type: ActionType.SMS.HANDLE_TO_CHANGE,
    payload: { newValue },
  })

export const handleBodyChange = string => dispatch =>
  dispatch({
    type: ActionType.SMS.HANDLE_BODY_CHANGE,
    payload: string,
  })

export const sendText = () => (dispatch, getState) => {
  dispatch({
    type: ActionType.SMS.SEND_REQUEST,
  })

  const recipient =
    getState().contacts.contactsWithEmailsByID[getState().sms.contactID].phone
  const messageBody = getState().sms.body

  const body = JSON.stringify({
    messages: [
      {
        from_number: '+12156083977',
        client_id: 'test_one',
        recipient,
        contact_id: getState().sms.contactID,
        body: messageBody,
      },
    ],
  })

  return Auth.currentSession()
    .then(session => {
      const headerValue = `Bearer ${session.idToken.jwtToken}`

      return fetch(`${API_URL}/sms/send`, {
        body, // must match 'Content-Type' header
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        headers: {
          'content-type': 'application/json',
          authorization: headerValue,
        },
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, cors, *same-origin
        redirect: 'follow', // manual, *follow, error
        referrer: 'no-referrer', // *client, no-referrer
      })
        .then(res =>
          res.json().then(data => {
            if (!res.ok) {
              return { notOk: true, ...data }
            }
            return data
          }),
        )
        .then(payload =>
          dispatch({
            type: ActionType.SMS.SEND_SUCCESS,
            payload,
          }),
        )
        .catch(error =>
          dispatch({
            type: ActionType.SMS.SEND_FAILURE,
            payload: error,
          }),
        )
    })
    .catch(err => {
      console.log(err)
      if (err.code === 'UserNotFoundException') {
        window.localStorage.clear()
        window.location.reload(true)
      }
    })
}

export const sendSMS =
  (text, contact_id, recipient, from_number, media_url) =>
  (dispatch, getState) =>
    new Promise((resolve, reject) => {
      dispatch({
        type: ActionType.SMS.SEND_REQUEST,
        text,
        contact_id,
        recipient,
        from_number,
      })

      const body = JSON.stringify({
        messages: [
          {
            from_number,
            client_id: 'test_one',
            recipient,
            contact_id,
            body: text,
            media_url,
          },
        ],
      })

      return Auth.currentSession()
        .then(session => {
          const headerValue = `Bearer ${session.idToken.jwtToken}`

          return fetch(`${API_URL}/sms/send`, {
            body, // must match 'Content-Type' header
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            headers: {
              'content-type': 'application/json',
              authorization: headerValue,
            },
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, cors, *same-origin
            redirect: 'follow', // manual, *follow, error
            referrer: 'no-referrer', // *client, no-referrer
          })
            .then(res =>
              res.json().then(data => {
                if (!res.ok) {
                  return { notOk: true, ...data }
                }
                return data
              }),
            )
            .then(payload => {
              if (payload && payload.notOk) {
                dispatch({
                  type: ActionType.SMS.SEND_FAILURE,
                  payload,
                  notOk: true,
                })
                reject(payload)
                return
              }

              dispatch({
                type: ActionType.SMS.SEND_SUCCESS,
                payload,
              })
              resolve(payload)
            })
            .catch(error => {
              dispatch({
                type: ActionType.SMS.SEND_FAILURE,
                payload: error,
              })
              reject(error)
            })
        })
        .catch(err => {
          console.log(err)
          if (err.code === 'UserNotFoundException') {
            window.localStorage.clear()
            window.location.reload(true)
          }
        })
    })

export const createOrUpdateSmsTemplate = id => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    const TextPart = getState()?.tasks?.addOrEdit?.sms?.value
    const email = getState()?.email
    const default_template_values = email?.defaultValues
    const name =
      email?.templateName?.value ||
      `Text message template created ${new Date().toLocaleString()}`

    if (!id || id === 'new' || id === 'preload') {
      return dispatch(
        create({
          entity: { Template: { TextPart }, default_template_values, name },
          entityType: 'sms/template',
        }),
      ).then(
        payload => resolve(payload),
        error => reject(error),
      )
    } else {
      return dispatch(
        update(
          {
            Template: { TextPart },
            default_template_values,
            name,
            id,
          },
          'sms/template',
          undefined,
          '',
          undefined,
          true,
        ),
      ).then(
        payload => resolve(payload),
        error => reject(error),
      )
    }
  })
